// extracted by mini-css-extract-plugin
export var icon = "_4e-3";
export var subtitle = "_4e-2";
export var title = "_4e-1";
export var value = "_4e-0";